import * as React from 'react';
import {
    Alert, AlertTitle,
    Avatar, Collapse,
    Stack,
} from '@mui/material';
import { LockOutlined, NotificationsNone } from "@mui/icons-material";
import "../login/custom.css"
import { getServiceLabel } from "../globalMethods/myConfig";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useState } from "react";

const orbitron = "'Orbitron', sans-serif";

const GALAXY_BG = `
    linear-gradient(rgba(0,0,0,0.82), rgba(0,0,0,0.88)),
    url('https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1920&q=80') center/cover no-repeat fixed
`;

const MessageLayout = ({ message, title, type }) => {

    const [showError, setShowError] = useState(false);

    return (
        <Box sx={{
            minHeight: "100vh",
            background: GALAXY_BG,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: orbitron,
            px: 2,
            py: 6,
        }}>

            {/* Blue grid overlay */}
            <Box sx={{
                position: "fixed", inset: 0,
                backgroundImage: `linear-gradient(rgba(21,101,192,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(21,101,192,0.06) 1px, transparent 1px)`,
                backgroundSize: "40px 40px", pointerEvents: "none", zIndex: 0,
            }} />

            <Box sx={{
                position: "relative", zIndex: 1, width: "100%", maxWidth: 520,
                background: "rgba(5,5,15,0.85)", backdropFilter: "blur(16px)",
                border: "1px solid #1565c0", borderRadius: 3, overflow: "hidden",
                boxShadow: "0 0 60px rgba(21,101,192,0.3), 0 0 120px rgba(21,101,192,0.1)",
            }}>

                {/* Blue top bar */}
                <Box sx={{
                    background: "#1565c0", py: 2, px: 3,
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5,
                }}>
                    <Avatar sx={{ bgcolor: "#000", width: 32, height: 32 }}>
                        <LockOutlined sx={{ fontSize: 18, color: "#1e88e5" }} />
                    </Avatar>
                    <Typography sx={{
                        fontFamily: orbitron, fontWeight: 900, fontSize: "0.85rem",
                        letterSpacing: 3, color: "#fff", textTransform: "uppercase",
                    }}>
                        KM-BIZZ · INFORMATION
                    </Typography>
                </Box>

                <Box sx={{ px: 4, pt: 4, pb: 4 }}>

                    {/* Service label */}
                    <Typography sx={{
                        fontFamily: orbitron, fontSize: "0.65rem", letterSpacing: 3,
                        color: "#1e88e5", textAlign: "center", mb: 3, textTransform: "uppercase",
                    }}>
                        {getServiceLabel()}
                    </Typography>

                    {/* Notification icon + title */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, mb: 3 }}>
                        <NotificationsNone sx={{ color: "#1e88e5", fontSize: 22 }} />
                        <Typography sx={{
                            fontFamily: orbitron, fontWeight: 700, fontSize: "0.8rem",
                            letterSpacing: 2, color: "#fff", textTransform: "uppercase",
                        }}>
                            User Notifications
                        </Typography>
                    </Box>

                    <Divider sx={{ borderColor: "rgba(21,101,192,0.2)", mb: 3 }} />

                    {/* Main alert */}
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert
                            severity={type}
                            sx={{
                                fontFamily: orbitron,
                                fontSize: "0.72rem",
                                letterSpacing: 0.5,
                                lineHeight: 1.8,
                                background: type === "success"
                                    ? "rgba(46,125,50,0.12)"
                                    : type === "error"
                                        ? "rgba(183,28,28,0.12)"
                                        : type === "warning"
                                            ? "rgba(230,81,0,0.12)"
                                            : "rgba(21,101,192,0.12)",
                                border: type === "success"
                                    ? "1px solid rgba(46,125,50,0.4)"
                                    : type === "error"
                                        ? "1px solid rgba(183,28,28,0.4)"
                                        : type === "warning"
                                            ? "1px solid rgba(230,81,0,0.4)"
                                            : "1px solid rgba(21,101,192,0.4)",
                                color: "#fff",
                                borderRadius: 2,
                                "& .MuiAlert-icon": { fontSize: 22 },
                            }}
                        >
                            <AlertTitle sx={{
                                fontFamily: orbitron,
                                fontSize: "0.85rem",
                                fontWeight: 700,
                                letterSpacing: 2,
                                textTransform: "uppercase",
                                color: "#fff",
                                mb: 0.5,
                            }}>
                                {title}
                            </AlertTitle>
                            {message}
                        </Alert>
                    </Stack>

                    {/* Collapsible error */}
                    <Collapse in={showError} sx={{ mt: 2 }}>
                        <Alert
                            severity="error"
                            onClose={() => setShowError(false)}
                            sx={{
                                fontFamily: orbitron,
                                fontSize: "0.68rem",
                                letterSpacing: 0.5,
                                background: "rgba(183,28,28,0.12)",
                                border: "1px solid rgba(183,28,28,0.4)",
                                color: "#fff",
                                borderRadius: 2,
                                "& .MuiAlert-icon": { fontSize: 20 },
                                "& .MuiAlert-action .MuiIconButton-root": { color: "rgba(255,255,255,0.6)" },
                            }}
                        >
                            <AlertTitle sx={{
                                fontFamily: orbitron,
                                fontSize: "0.75rem",
                                fontWeight: 700,
                                letterSpacing: 2,
                                textTransform: "uppercase",
                                color: "#fff",
                            }}>
                                Error
                            </AlertTitle>
                            There was an issue processing your request. Please check your internet connection and try again.
                            <strong style={{ color: "#ef9a9a" }}> Error Code: 500</strong>
                        </Alert>
                    </Collapse>

                </Box>
            </Box>
        </Box>
    );
}

export default MessageLayout;
